export default __webpack_public_path__ + "static/media/bnr1.eb6dc07f.jpg";